let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0XYL")).then(() => parcelRequire('4SXj5'));